import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { t } from "i18next";
import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaginationUI from "../atoms/PaginationUI";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import EllipsesMenuTrainingPlan from "../molecules/EllipsesMenuTrainingPlan";

type TrainingProps = {
  id: number | string;
  name: string;
  objective: string;
  weeks: string;
  days?: string;
};

export type TableListPlanProps = {
  trainings: TrainingProps[];
  description: string;
  isLoading: boolean;
  OnDuplicate: () => void;
  onAssing: () => void;
  onEdit: () => void;
};

const TableListPlan: React.FC<TableListPlanProps> = ({
  description,
  trainings,
  isLoading,
  OnDuplicate,
  onAssing,
  onEdit,
}) => {
  return (
    <div className="px-2 mt-5">
      <div className="sm:flex sm:items-center">
        <div className="flex-grow">
          <p className="mt-2 text-sm text-gray-700">{description}</p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0"></div>
      </div>

      {/* Divider debajo del texto */}
      <div className="border-b border-gray-300 my-3"></div>

      <div className="sm:flex sm:items-center">
        <div className="sm:flex w-64">
          <InputWithCornerHint
            label={t("gym.views.search")}
            id="search"
            name="search"
            type="text"
            placeholder={t("gym.views.search")}
          />
        </div>
        <div className="mt-8 sm:ml-auto sm:mt-4 sm:justify-between"></div>
      </div>

      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        {!isLoading === false ? (
          <>
            <div className="flex justify-center items-center m-10">
              <FontAwesomeIcon icon={faLoader} spin className="text-6xl" />
            </div>
          </>
        ) : (
          <>
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">
                {trainings.length === 0 ? (
                  <div className="my-5">
                    <Empty texto={t("gym.views.no_gyms")} />
                  </div>
                ) : (
                  <Fragment>
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                          >
                            {t("gym.views.name")}
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            {t("user.views.table_plan_obj")}
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            {t("user.views.table_plan_semanas")}
                          </th>
                          {trainings[0].days !== undefined ? (
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              {t("user.views.table_plan_days")}
                            </th>
                          ) : (
                            <></>
                          )}
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {trainings.map((training) => (
                          <tr key={training.id}>
                            <ColumnText title={training.name} />
                            <ColumnText title={training.objective} />
                            <ColumnText title={training.weeks} />
                            {trainings[0].days !== undefined ? (
                              <ColumnText title={training.days} />
                            ) : (
                              <></>
                            )}
                            <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 flex items-center space-x-2">
                              <EllipsesMenuTrainingPlan
                                onDuplicate={OnDuplicate}
                                onAssing={onAssing}
                                onEdit={onEdit}
                              />
                              <a
                                onClick={() => {}}
                                href="#"
                                className="text-red-600 hover:text-red-900"
                              >
                                <FontAwesomeIcon icon={faTrashCan} />
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Fragment>
                )}
              </div>
            </div>
            <div className="mt-5">
              <PaginationUI
                currentPage={1}
                totalPages={1}
                onPageChange={() => {}}
                pageSize={1}
                totalResults={1}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TableListPlan;
